module.exports = __webpack_public_path__ + "static/media/gc-blackfriday.6de51d42.jpg";